import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

import root from './utils'

type ChatProps = {
  currentCard: any
  allCard: {
    perception: any
    judge: any
    action: any
    social: any
    individuality: any
    insane: any
  }
  userScore: {
    perception: number
    judge: number
    action: number
    social: number
    individuality: number
    insane: number
  }
}

const initialState = {
  currentCard: null,
  allCard: {
    perception: {},
    judge: {},
    action: {},
    social: {},
    individuality: {},
    insane: {},
  },
  userScore: {
    perception: 0,
    judge: 0,
    action: 0,
    social: 0,
    individuality: 0,
    insane: 0,
  },
} as ChatProps

// const root = 'http://mock.ixiaochuan.cn/mock/412'
export const setCard = createAsyncThunk<any, any>(
  'setCard',
  async (arg, store) => {
    return req(
      '/xai_select_identity',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const cancelCard = createAsyncThunk<any, any>(
  'cancelCard',
  async (arg, store) => {
    return req(
      '/xai_cancel_identity',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getUserCrad = createAsyncThunk<any, any>(
  'getUserCrad',
  async (arg, store) => {
    return req(
      '/xai_get_user_identity',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getUserScoce = createAsyncThunk<any, any>(
  'getUserScoce',
  async (arg, store) => {
    return req(
      '/xai_get_user_features_score',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getChatInfo = createAsyncThunk<any, any>(
  'getChatInfo',
  async (arg, store) => {
    return req(
      '/xai_get_chat_info',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getAllCard = createAsyncThunk<any, any>(
  'getAllCard',
  async (arg, store) => {
    return req(
      '/xai_get_identities',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getNewCard = createAsyncThunk<any, any>(
  'getNewCard',
  async (arg, store) => {
    return req(
      '/xai_get_newly_unlocked_identities',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getNewCardUpdateStatus = createAsyncThunk<any, any>(
  'getNewCardUpdateStatus',
  async (arg, store) => {
    return req(
      '/xai_change_identity_new_status',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const showExplainCallback = createAsyncThunk<any, any>(
  'showExplainCallback',
  async (arg, store) => {
    return req(
      '/xai_update_user_feature_interpretation_status',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const reportSlice = createSlice({
  name: 'card',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserScoce.fulfilled, (state, action) => {
      return {
        ...state,
        userScore: action.payload,
      }
    })
    builder.addCase(getAllCard.fulfilled, (state, action) => {
      return {
        ...state,
        allCard: action.payload,
      }
    })
    builder.addCase(getUserCrad.fulfilled, (state, action) => {
      return {
        ...state,
        currentCard: action.payload,
      }
    })
  },
})

export default reportSlice.reducer
